import { pickBy, isEqual } from 'lodash-es'

export { isEmpty, pickBy, isEqual, groupBy, merge as mergeObjects } from 'lodash-es'
export { isNil, pick, size } from 'lodash-es'
export {
  clean,
  cloneDeep,
  isBlank,
  isPresent,
  presence,
  isPlainObject
  as isObject,
  deepCamelizeKeys,
  deepDecamelizeKeys,
} from '@shared/object'

// Public: Intersects attributes for every object, keeping only the properties
// that have the same value for every object in the collection.
export function intersectObjects<T extends Record<string, any>> (objects: T[]): Partial<T> {
  return objects.reduce((intersection, object) =>
    pickBy(intersection, (value, field) => isEqual(object[field], value)) as T,
  )
}

// Public: Consistent with the Rails definition.
export function indexBy<T extends object> (items: readonly T[], key: keyof T) {
  const object: Record<string, T> = {}
  items.forEach((item) => { object[item[key] as any] = item })
  return object
}
